import Pagy from "pagy.mjs";
window.addEventListener("turbo:load", Pagy.init)
window.addEventListener("turbo:frame-load", Pagy.init)
window.addEventListener("turbo:before-stream-render", (event) => {
  setTimeout(Pagy.init, 1)
})